import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../_constants/validation-format-constants';
import { BaseParameterDto } from '../../_models/base-parameter-dto';

export class SearchParametersDto extends BaseParameterDto {
    communityId: number;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    startDate: Date;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    endDate: Date;
    searchText: string;

    getQueryString(): string {
        const tokens = [];
        if (!!this.communityId) {
            tokens.push(`communityId=${this.communityId}`);
        }
        if (!!this.startDate) {
            tokens.push(`startDate=${dateJSONTransformer(this.startDate)}`);
        }
        if (!!this.endDate) {
            tokens.push(`endDate=${dateJSONTransformer(this.endDate)}`);
        }
        if (!!this.searchText) {
            tokens.push(`searchText=${encodeURIComponent(this.searchText)}`);
        }
        tokens.push(`clearCache=${this.clearCache}`);
        return `?${tokens.join('&')}`;
    }
}
